module.exports = __webpack_public_path__ + "img/detail_bottom_icon.dea5d6df.png";